"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateBillingModelSchema = exports.BillingReasonType = exports.getDefaultBillingModelId = void 0;
const Joi = __importStar(require("joi"));
const case_vouchers_1 = require("../case-vouchers");
const getDefaultBillingModelId = (creditor, tenant) => {
    var _a, _b;
    return (_b = (_a = creditor.defaultBillingModelId) !== null && _a !== void 0 ? _a : tenant.defaultBillingModelId) !== null && _b !== void 0 ? _b : null;
};
exports.getDefaultBillingModelId = getDefaultBillingModelId;
var BillingReasonType;
(function (BillingReasonType) {
    BillingReasonType["VoucherDeleted"] = "VOUCHER_DELETED";
    BillingReasonType["VoucherCreated"] = "VOUCHER_CREATED";
    BillingReasonType["VoucherPatched"] = "VOUCHER_PATCHED";
    BillingReasonType["BillingModelChanged"] = "BILLING_MODEL_CHANGED";
    BillingReasonType["BillingModelPatched"] = "BILLING_MODEL_PATCHED";
    BillingReasonType["BillingStartDateChanged"] = "BILLING_START_DATE_CHANGED";
    BillingReasonType["Reconciliation"] = "RECONCILIATION";
})(BillingReasonType || (exports.BillingReasonType = BillingReasonType = {}));
const ShareSchema = Joi.object({
    shareId: Joi.string().uuid().required(),
    feeFraction: Joi.number(),
    toVoucherTypeId: Joi.string(),
    toVoucherTypeIds: Joi.array().items(Joi.string()),
    voucherTypeIds: Joi.array().items(Joi.string()),
    categories: Joi.array().items(Joi.string()),
    caseTag: Joi.string(),
    caseVoucherTag: Joi.string(),
    caseVoucherSource: Joi.string().valid(...Object.values(case_vouchers_1.CaseVoucherSource)),
});
exports.CreateBillingModelSchema = Joi.object({
    name: Joi.string(),
    model: {
        share: Joi.array().items(ShareSchema),
        voucherCategoryPriority: Joi.array().items(Joi.string()),
        voucherTypePriority: Joi.array().items(Joi.string()),
        voucherDatePriorityNewFirst: Joi.bool(),
        voucherTagPriority: Joi.array().items(Joi.string()),
        fromVoucherTypeIds: Joi.array().items(Joi.string().uuid()),
        excludeVoucherTypeIds: Joi.array().items(Joi.string().uuid()),
        toVoucherTypeId: Joi.string().uuid().required(),
        clientDepositToVoucherTypeId: Joi.string().uuid().required(),
        preventNegativeCreditorBalance: Joi.bool(),
    },
});
//# sourceMappingURL=index.js.map